import { render, staticRenderFns } from "./RelationCard.vue?vue&type=template&id=34b8fc8c&scoped=true&"
import script from "./RelationCard.vue?vue&type=script&lang=js&"
export * from "./RelationCard.vue?vue&type=script&lang=js&"
import style0 from "./RelationCard.vue?vue&type=style&index=0&id=34b8fc8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8fc8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
